function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M7,11.8c-2.3,0-7,1.2-7,3.5V17h14v-1.8C14,12.9,9.3,11.8,7,11.8z M2.3,15c0.8-0.6,2.9-1.2,4.7-1.2 s3.8,0.7,4.7,1.2H2.3z M7,10c1.9,0,3.5-1.6,3.5-3.5S8.9,3,7,3S3.5,4.6,3.5,6.5S5.1,10,7,10z M7,5c0.8,0,1.5,0.7,1.5,1.5S7.8,8,7,8 S5.5,7.3,5.5,6.5S6.2,5,7,5z M14,11.8c1.2,0.8,2,2,2,3.4V17h4v-1.8C20,13.2,16.5,12.1,14,11.8L14,11.8z M13,10 c1.9,0,3.5-1.6,3.5-3.5S14.9,3,13,3c-0.5,0-1,0.1-1.5,0.3c0.6,0.9,1,2,1,3.2s-0.4,2.3-1,3.1C12,9.9,12.5,10,13,10z"
});

var SvgMoversPeople = function SvgMoversPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoversPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/movers_people.d078c6f1.svg";
export { ForwardRef as ReactComponent };